import CompanyMediaSerializers from '../serializers/CompanyMediaSerializers';
import {CompanyProfile} from '../types';

import * as api from '../../../../lib/api/v1/index';

export class CompanyMediaService {
  async updateCompanyMedia(
    companyId: string,
    companyMedia: CompanyProfile['companyMediaFiles']
  ): Promise<{companyMediaFiles: CompanyProfile['companyMediaFiles']}> {
    try {
      const response = await api.updateCompanyMedia(companyId, companyMedia);
      if (response.ok) {
        const payload = await response.json();
        return CompanyMediaSerializers.toObject(payload);
      }
      throw new Error('Could not update company profile');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Could not update company media');
    }
  }

  async createCompanyMedia(
    companyId: string,
    companyMedia: CompanyProfile['companyMediaFiles']
  ): Promise<{companyMediaFiles: CompanyProfile['companyMediaFiles']}> {
    try {
      const response = await api.createCompanyMedia(companyId, companyMedia);
      if (response.ok) {
        const payload = await response.json();
        return CompanyMediaSerializers.toObject(payload);
      }
      throw new Error('Could not update company profile');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Failed to create media');
    }
  }

  async deleteCompanyMedia(companyId: string, mediaIds: string[]) {
    try {
      await api.deleteCompanyMedia(companyId, mediaIds);
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Failed to delete media');
    }
  }
}
